import Icon from '@/components/icons/Icon';
import { capitalizeFirstLetter, isServer, restoreBodyScroll, saveBodyScroll } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import { __ } from '@/locale';
import React, { useEffect, useState } from 'react';
import Modal from './redesign/Modal/Modal';

type ReadMoreModalProps = {
  modalProps?: {
    title?: string;
    info?: React.ReactNode;
    button?: React.ReactNode;
    actionText?: string;
    isOpen?: boolean;
    handleOnClose?: Function;
    handleOnOpen?: Function;
  };
  className?: string;
  icon?: boolean;
};

const ReadMoreModal = ({ modalProps = {}, className = '', icon }: ReadMoreModalProps) => {
  const { isOpen, actionText = __('readMore'), handleOnClose, handleOnOpen } = modalProps;
  const [showModal, setShowModal] = useState(isOpen ?? false);
  const { isMobileView } = useMobileView();
  const styleClass = `cursor-pointer whitespace-nowrap text-fg_link underline ${className}`;

  useEffect(() => {
    setShowModal(isOpen);
  }, [isOpen]);

  const handleCloseModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowModal(false);
    if (handleOnClose) {
      handleOnClose();
    }
    restoreBodyScroll();
  };

  const handleShowModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    saveBodyScroll();
    setShowModal(!showModal);
    if (handleOnOpen) {
      handleOnOpen();
    }
  };

  const handleClickModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const getModal = () => {
    const { title = '', info = '', button } = modalProps;

    return !isServer ? (
      <Modal isOpen={showModal} onRequestClose={handleCloseModal}>
        <Modal.Content floating={!isMobileView}>
          <div onClick={handleClickModal}>
            <Modal.Header onClose={handleCloseModal} title={capitalizeFirstLetter(title)} />
            <div className="container py-4">
              <div className="mb-8 whitespace-pre-wrap">{info}</div>
              {button}
            </div>
          </div>
        </Modal.Content>
      </Modal>
    ) : null;
  };

  return (
    <>
      {icon && (
        <button className="outline-none" onClick={handleShowModal}>
          <Icon variant="info-circle" style={{ width: '20px', height: '20px' }} color="fg_link" />
        </button>
      )}
      {!icon && (
        <span className={styleClass} onClick={handleShowModal}>
          {actionText}
        </span>
      )}
      {showModal && modalProps && getModal()}
    </>
  );
};

export default ReadMoreModal;
